__turbopack_context__.v({
  "boxLabel": "_3kR7qG_boxLabel",
});
